export default __webpack_public_path__ + "static/media/rectangle.e50d6e51.svg";